export const SERVICES = [
  {
    slug: "individual-tax-returns",
    name: "Individual Tax Returns",
    short: "Simplify your filing with expert individual tax return services. We ensure accuracy and maximize your refund.",
    summary: "Federal and Florida tax filing for W-2 earners, freelancers, investors, and retirees.",
    features: [
      "Form 1040, 1040-SR & Schedule C/E preparation",
      "Itemized vs. standard deduction analysis",
      "Secure filing with refund status updates",
      "Prior-year tax review and amendments",
    ],
    image: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "small-business-accounting",
    name: "Small Business Accounting",
    short: "Comprehensive accounting solutions tailored for small businesses. We handle your books so you can focus on growth.",
    summary: "Full-scope tax strategies and compliance for LLCs, S-Corps, C-Corps, and partnerships.",
    features: [
      "Form 1120, 1120-S & 1065 filings",
      "Quarterly estimated tax calculations",
      "Sales & use tax reporting (Florida Dept. of Revenue)",
      "Entity structure optimization",
    ],
    image: "https://images.unsplash.com/photo-1681505531034-8d67054e07f6?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "tax-planning",
    name: "Tax Planning",
    short: "Plan for the future with strategic tax planning. We help minimize liabilities and optimize your financial strategy.",
    summary: "Proactive, year-round strategies to legally minimize tax liabilities before filing deadlines.",
    features: [
      "Year-end deduction acceleration",
      "Retirement account contribution advice",
      "Real estate & depreciation strategies",
      "Capital gains tax mitigation",
    ],
    image: "https://images.unsplash.com/photo-1707902665498-a202981fb5ac?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "financial-consulting",
    name: "Financial Consulting",
    short: "Expert advice on your financial matters. Personalized consulting to help you make informed decisions.",
    summary: "Actionable financial insight to maximize profit margins and manage operational risk.",
    features: [
      "Budgeting & cash flow forecasting",
      "Business valuation assistance",
      "Debt refinancing & loan preparation",
      "Cost center efficiency analysis",
    ],
    image: "https://images.unsplash.com/photo-1549923746-c502d488b3ea?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "bookkeeping",
    name: "Bookkeeping Service",
    short: "Reliable bookkeeping to help small businesses and individuals stay organized, manage finances, and make smarter decisions.",
    summary: "Clean, accurate, monthly financial ledger maintenance for stress-free operations.",
    features: [
      "Bank & credit card reconciliation",
      "Monthly profit & loss statements",
      "Accounts payable & receivable",
      "QuickBooks & Xero support",
    ],
    image: "https://images.unsplash.com/photo-1626266061368-46a8f578ddd6?crop=entropy&cs=srgb&fm=jpg&q=85",
    dedicated: true,
  },
];
